import { useIntl } from 'react-intl';
import { format } from 'date-fns';

import Chip from 'src/componentes/chip';
import useAuth from 'src/hooks/useAuth';
import formatDateFns from 'src/utils/formatDateFns';
import { capitalizeFirstLetter } from 'src/utils/string';

const getLookupItemLabel = (item) =>
  item?.descricao ?? item?.Descricao ?? item?.nome ?? item?.Nome;

const RespostasFiltroChips = ({
  className = 'mb-3',
  ehConfidencial = false,
  filtros,
  onRemove,
  style,
}) => {
  const intl = useIntl();
  const { terms: resources, user } = useAuth();
  const { currentDisplay, currentLocale } = formatDateFns(user?.idioma, true);

  const formatData = (data) =>
    data
      ? format(new Date(data), currentDisplay, { locale: currentLocale })
      : '';

  const getColaboradoresGruposChipLabel = () => {
    const hasGrupo = filtros.colaboradoresGrupos.some(
      (item) => item.identificadorLista === 'grupos'
    );
    const hasColaborador = filtros.colaboradoresGrupos.some(
      (item) => item.identificadorLista !== 'grupos'
    );

    if (hasGrupo && !hasColaborador) {
      return intl.formatMessage({ id: 'grupos' });
    }

    if (hasGrupo && hasColaborador) {
      return `${resources.colaboradores} / ${intl.formatMessage({
        id: 'grupos',
      })}`;
    }

    return resources.colaboradores;
  };

  const chips = [];

  if (filtros.areas?.length) {
    chips.push({
      key: 'areas',
      label: `${capitalizeFirstLetter(
        resources.areas || resources.area
      )}: ${filtros.areas.map((area) => area.nome).join(', ')}`,
    });
  }

  if (filtros.considerarAreasSubordinadas) {
    chips.push({
      key: 'considerarAreasSubordinadas',
      label: capitalizeFirstLetter(
        intl.formatMessage(
          { id: 'label.considerarAreasSubordinadas' },
          { areas: resources.areas }
        )
      ),
    });
  }

  if (!ehConfidencial && filtros.colaboradoresGrupos?.length) {
    chips.push({
      key: 'colaboradoresGrupos',
      label: `${capitalizeFirstLetter(
        getColaboradoresGruposChipLabel()
      )}: ${filtros.colaboradoresGrupos
        .map(getLookupItemLabel)
        .filter(Boolean)
        .join(', ')}`,
    });
  }

  if (filtros.dataEnvioInicio) {
    chips.push({
      key: 'dataEnvioInicio',
      label: `${intl.formatMessage({
        id: 'labelDataEnvioInicio',
      })}: ${formatData(filtros.dataEnvioInicio)}`,
    });
  }

  if (filtros.dataEnvioFim) {
    chips.push({
      key: 'dataEnvioFim',
      label: `${intl.formatMessage({ id: 'labelDataEnvioFim' })}: ${formatData(
        filtros.dataEnvioFim
      )}`,
    });
  }

  if (chips.length === 0) return null;

  return (
    <div
      className={`d-flex flex-wrap align-items-center ${className}`}
      style={{ gap: 8, ...style }}
    >
      {chips.map((chip) => (
        <Chip
          key={chip.key}
          label={chip.label}
          onDelete={() => onRemove(chip.key)}
        />
      ))}
    </div>
  );
};

export default RespostasFiltroChips;
